export default __webpack_public_path__ + "static/media/copy-svgrepo-com.fcb3af27.svg";